import { render, staticRenderFns } from "./TopBarSharing.vue?vue&type=template&id=34487171&"
import script from "./TopBarSharing.vue?vue&type=script&lang=js&"
export * from "./TopBarSharing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports